'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fad';
var iconName = 'starship';
var width = 640;
var height = 512;
var ligatures = [];
var unicode = 'e039';
var svgPathData = ['M208,96H24A23.99993,23.99993,0,0,0,0,120v16a24.00118,24.00118,0,0,0,24,24H208a32,32,0,0,0,0-64Zm0,256H24A23.99993,23.99993,0,0,0,0,376v16a24.00118,24.00118,0,0,0,24,24H208a32,32,0,0,0,0-64ZM448,64c-106.03906,0-192,85.96094-192,192s85.96094,192,192,192,192-85.96094,192-192S554.03906,64,448,64Zm0,256a64,64,0,1,1,64-64A64.07333,64.07333,0,0,1,448,320Z', 'M208.25,210.88672,160,160H86.23828l55.32422,56.94922-10.79688.98047a38.22631,38.22631,0,0,0,0,76.13867l10.79688.98242L64,352h73.76172L208.25,301.11328l54.40234,4.28516a186.73576,186.73576,0,0,1,0-98.79688ZM448,192a64,64,0,1,0,64,64A64.07333,64.07333,0,0,0,448,192Zm0,96a32,32,0,1,1,32-32A32.00158,32.00158,0,0,1,448,288Z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.faStarship = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = ligatures;
exports.unicode = unicode;
exports.svgPathData = svgPathData;